import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-completar-validacion-documento',
  templateUrl: './completar-validacion-documento.component.html',
  styleUrls: ['./completar-validacion-documento.component.scss'],
})
export class CompletarValidacionDocumentoComponent implements OnInit {
  form: FormGroup;

  tipo_validaciones = ['Cheque de Gerencia', 'Transferencia Interbancaria'];
  @Input() data: { task: any };

  constructor(private fb: FormBuilder) {}

  ngOnInit(): void {
    const { task } = this.data;
    const values = task.data ? task.data : null;
    this.form = this.fb.group({
      tipo_docuemnto: [
        values ? values.tipo_docuemnto : '',
        [Validators.required],
      ],
      ente: [values ? values.ente : '', [Validators.required]],
      ci_persona: [values ? values.ci_persona : '', [Validators.required]],
      nombre_apellido: [
        values ? values.nombre_apellido : '',
        [Validators.required],
      ],
    });
  }

  verificateInput(value: string) {
    return (
      this.form.get(value)?.invalid &&
      (this.form.get(value)?.dirty || this.form.get(value)?.touched)
    );
  }
}
